import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import useApi from '../../api/useApi';
import PrinterDetail from '../PrinterDetail';
import '../../scrollbar.css';
import ZipFiles from '../../components/ZplFiles';

function Printers() {
  const [{ isLoading, isError, data }, getData] = useApi();

  const [printers, setPrinter] = useState([]);
  const [selectedPrinter, selectPrinter] = useState({ id: '' });
  const [printerDetail, showPrinterDetail] = useState(false);
  const [showZipFiles, setShowZipFiles] = useState(false);
  const [formData, setFormData] = useState({ q: '', scope: '', parameter: '' });

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));

  const user = sessionStorage.getItem('user');

  if (!user) {
    location.href = '/';
  }

  const orgId = user && JSON.parse(sessionStorage.user).organization.id;

  useEffect(() => {
    user && getData(`/organization/${orgId}/printers`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setPrinter(data.printers);
    }
  }, [isLoading, isError, data]);

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    return moment(_date).fromNow();
  };

  const searchData = () => {
    getData(`/organization/${orgId}/search?type=printer&searchItem=${formData.q}`, 'GET');
  };

  useEffect(() => {
    if (formData.q === '') {
      getData(`/organization/${orgId}/printers`, 'GET');
    }
  }, [formData.q]);

  const toggleOpenPrinterDetail = () => {
    showPrinterDetail(false);
  };

  return (
    <>
      {showZipFiles && (
        <ZipFiles
          orgId={orgId}
          goBack={() => {
            setShowZipFiles(false);
          }}
        />
      )}

      {!printerDetail && !showZipFiles && (
        <div className="mt-10 h-full bg-white mx-auto px-3 rules_ui overflow-auto">
          <div className="z-50" style={{ height: '21vh', paddingBottom: '4vh' }}>
            <div
              className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
              style={{ paddingTop: '4vh' }}
            >
              <span className="text-titleColor font-bold text-base mobile_icon2">Printers</span>

              <div className="block lg:flex mt-1 lg:mt-0 ">
                <button
                  className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile2 "
                  onClick={() => {
                    setShowZipFiles(true);
                  }}
                >
                  ZPL Files
                  {/* <img src="assets/img/download.svg" className="h-3 ml-2 transform -rotate-270" alt="" /> */}
                </button>
                <button
                  className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile2 "
                  onClick={() => {
                    // downloadExcel('tblData');
                  }}
                >
                  Report
                  <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
                </button>
                <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 py-1.5 ml-3 flex justify-between items-center rounded-3xl button_search2">
                  <input
                    type="text"
                    placeholder="Search"
                    autoComplete="off"
                    className="text-textBox bg-transparent focus:outline-none button_search2"
                    value={formData.q}
                    name="q"
                    onChange={handleInputChange}
                    style={{ borderColor: '#e6e6e6' }}
                    onKeyDown={(e) => {
                      if (e.which === 13) searchData();
                    }}
                  />
                  <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 button_search3 " alt="" />
                </div>
              </div>
            </div>
          </div>

          <div className="tbl mobile_view1" style={{ minWidth: '700px' }}>
            <div className="bg-white w-tableWidth m-auto mb-3">
              <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
                <div className="px-8 py-1.5 flex w-full relative bg-primary text-white items-center resp_rule">
                  <div className=" py-2.5 text-xs font-bold w-3/12">ID</div>
                  <div className=" py-2.5 text-xs font-bold w-3/12">STATUS</div>
                  <div className=" py-2.5 text-xs font-bold w-3/12">LAST MODIFIED</div>
                  <div className=" py-2.5 text-xs font-bold w-3/12">ACTIONS</div>
                </div>
              </div>
              {!isLoading ? (
                <div className="hideScroll" style={{ overflowY: 'scroll', height: '70vh' }}>
                  <div className="w-full">
                    {printers.map((item) => (
                      <div
                        className="my-2 px-8 py-1 xl:py-1.5 items-center flex
                      relative hover:border-indigo-200 focus-within:border-indigo-200 focus:bg-rowSelect hover:bg-rowSelect"
                        style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                      >
                        <a
                          href="#"
                          className="text-primary font-semibold phone_font md:no-underline md:hover:underline text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12 cursor-pointer"
                          onClick={() => {
                            showPrinterDetail(true);
                            selectPrinter({ id: item?.id });
                          }}
                        >
                          {item?.id}
                        </a>
                        <div
                          className={`text-${
                            item?.isActive ? 'green-600' : 'red-600'
                          } font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12`}
                        >
                          {item?.isActive ? 'Active' : 'Inactive'}
                        </div>
                        <div className="text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          {getTimeoffset(item?.updatedAt)}
                        </div>
                        <div className="flex text-role font-semibold text-left py-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-3/12">
                          <img
                            src="assets/img/Edit2.svg"
                            className="h-3 mr-2"
                            alt=""
                            // onClick={() => {
                            //   selectrule({ id: item?.id });
                            //   setAction('update');
                            //   toggleOpenCreate();
                            // }}
                          />
                          <img
                            src="assets/img/Delete2.svg"
                            className="h-3 mr-2"
                            alt=""
                            // onClick={() => {
                            //   selectrule({ id: item?.id });
                            //   setOnClose(true);
                            // }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
              )}
            </div>
          </div>
        </div>
      )}
      {printerDetail && (
        <PrinterDetail printerId={selectedPrinter?.id} handleClose={toggleOpenPrinterDetail} orgId={orgId} />
      )}
    </>
  );
}

export default Printers;
